import { render, staticRenderFns } from "./workfile-add-or-update.vue?vue&type=template&id=2e498b3c&scoped=true&"
import script from "./workfile-add-or-update.vue?vue&type=script&lang=js&"
export * from "./workfile-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./workfile-add-or-update.vue?vue&type=style&index=0&id=2e498b3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e498b3c",
  null
  
)

export default component.exports